import React from 'react';
import MuiIconButton from '@mui/material/IconButton';

const IconButton = (props) => <MuiIconButton {...props} />;

export default IconButton;
